import React from 'react';
import pluralize from 'pluralize';
import { ProjectGrowthAlertChart } from './ProjectGrowthAlertChart.esm.js';
import { InfoCard } from '@backstage/core-components';

const ProjectGrowthAlertCard = ({ alert }) => {
  const subheader = `
    ${pluralize("product", alert.products.length, true)}${alert.products.length > 1 ? ", sorted by cost" : ""}`;
  return /* @__PURE__ */ React.createElement(
    InfoCard,
    {
      title: `Project growth for ${alert.project}`,
      subheader
    },
    /* @__PURE__ */ React.createElement(ProjectGrowthAlertChart, { alert })
  );
};

export { ProjectGrowthAlertCard };
//# sourceMappingURL=ProjectGrowthAlertCard.esm.js.map
